import type { Llm } from '@type/llm';
import { Computer, SmartToy } from '@mui/icons-material';
import { SvgIcon } from '@mui/material';
import React from 'react';

interface ModelIconProps {
  model?: Llm;
  fontSize?: 'small' | 'medium' | 'large' | 'inherit';
}

export const ModelIcon: React.FC<ModelIconProps> = ({ model, fontSize = 'small' }) => {
  // Default to SmartToy icon if no model specified
  if (!model) {
    return <SmartToy fontSize={fontSize} />;
  }

  switch (model) {
    case 'OPENAI':
      return (
        <SvgIcon fontSize={fontSize} viewBox="0 0 24 24">
          <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.78.78 0 0 0 .78 0l5.843-3.369v2.332a.074.074 0 0 1-.028.057l-4.832 2.795a4.504 4.504 0 0 1-6.153-1.645zm-.856-8.246a4.476 4.476 0 0 1 2.346-1.973l-.004.162v5.517a.787.787 0 0 0 .392.681l5.843 3.369-2.02 1.168a.069.069 0 0 1-.066 0l-4.827-2.79a4.504 4.504 0 0 1-1.664-6.134zm16.008 3.73-5.843-3.369 2.02-1.168a.07.07 0 0 1 .066 0l4.827 2.79a4.494 4.494 0 0 1-1.12 8.107v-5.517a.795.795 0 0 0-.397-.681zm2.253-3.395a4.47 4.47 0 0 1-.535.983l-.142-.085-4.779-2.759a.78.78 0 0 0-.78 0L8.927 11.9V9.569a.07.07 0 0 1 .028-.057l4.827-2.79a4.504 4.504 0 0 1 6.682 2.771zm-12.35 3.369-2.02-1.168a.067.067 0 0 1-.037-.052V7.967a4.504 4.504 0 0 1 7.37-3.454l-.142.081-4.779 2.759a.795.795 0 0 0-.392.681zm1.069-2.332 2.606-1.507 2.606 1.507v3.014l-2.606 1.507-2.606-1.507z" />
        </SvgIcon>
      );
    case 'ANTHROPIC_CLAUDE':
      return (
        <SvgIcon fontSize={fontSize} viewBox="0 0 24 24">
          <path d="M15.5 2.25a4.25 4.25 0 0 0-4.25 4.25h-2.5A6.75 6.75 0 0 1 15.5 0h2.5v2.25zM2.25 8.5A4.25 4.25 0 0 0 6.5 12.75v2.5A6.75 6.75 0 0 1 0 8.5v-2.5h2.25zM8.5 21.75a4.25 4.25 0 0 0 4.25-4.25h2.5A6.75 6.75 0 0 1 8.5 24H6v-2.25zM21.75 15.5a4.25 4.25 0 0 0-4.25-4.25v-2.5A6.75 6.75 0 0 1 24 15.5V18h-2.25z" />
          <path d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
        </SvgIcon>
      );
    case 'GOOGLE_GEMINI':
      return (
        <SvgIcon fontSize={fontSize} viewBox="0 0 24 24">
          <path d="M4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8m8-10c-5.51 0-10 4.49-10 10s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2m2.5 10c0 1.38-1.12 2.5-2.5 2.5S9.5 13.38 9.5 12 10.62 9.5 12 9.5s2.5 1.12 2.5 2.5M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6m0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4" />
        </SvgIcon>
      );
    case 'OLLAMA':
      // Local model running on the user's own machine.
      return <Computer fontSize={fontSize} />;
    default:
      return <SmartToy fontSize={fontSize} />;
  }
};
